import dayjs from 'dayjs'
import groupBy from 'lodash-es/groupBy'
import reverse from 'lodash-es/reverse'
import sortBy from 'lodash-es/sortBy'
import type { TimelineEvent } from './types'

const sortEvents = (events?: TimelineEvent[]) => reverse(sortBy(events, ['happenedAt']))

export const getSections = (events?: TimelineEvent[]) => {
  const sortedEvents = sortEvents(events)

  return groupBy(
    sortedEvents,
    ({ happenedAt }) => happenedAt && dayjs(happenedAt).format('MM DD YY'),
  )
}
